import { UserType } from "../types/userType";

export function isAdmin(user?: UserType) {
  return user?.role?.type === "administrator";
}
export function isAuthorizer(user?: UserType) {
  return (user?.role?.type === "authorizer" || user?.role?.type === "motion_support");
}
export function isSalesRep(user?: UserType) {
  return user?.role?.type === "sales_rep";
}
export function isMotionSupport(user?: UserType) {
  return user?.role?.type === "motion_support";
}
